// JavaScript Document





function someCallback(args) {
    var currentSlideNumber = args.currentSlideNumber;

}

function initGallerySlider(_sliderId, gotoHashImgNo) {
    if ($(_sliderId).length <= 0) return false;
    if (gotoHashImgNo === undefined || gotoHashImgNo <= 0)
        gotoHashImgNo = 1;
    $(_sliderId).iosSlider({
        snapToChildren: true,
        scrollbar: false,
        scrollbarHide: true,
        desktopClickDrag: true,
        autoSlide: false,
        startAtSlide: gotoHashImgNo,
        navPrevSelector: $('.prev'),
        navNextSelector: $('.next'),
        onSlideChange: someCallback,
        infiniteSlider: true,

    });
}

function openGallery(_elem) {
    var currentPos = parseInt($(_elem).offset().top);
    var input = JSON.parse($(_elem).attr('data-slideItems'));
    var output = '<div class="galWrapper"><div id="gal' + input.slideId + '" class = "iosSliderGal"><div class = "slider">';
    for(var i in input.slideEl) {
        var slideNr = (parseInt(i) + parseInt(1));
        output += '<div class = "slide item' + slideNr + '"style="background-image:url(\'' + input.slideEl[i] + '\')"></div>';
    }
    output += '</div></div><div class="navButtons"><div class="prev"><i class="fa fa-chevron-left" aria-hidden="true"></i></div><div class="next"><i class="fa fa-chevron-right" aria-hidden="true"></i></div></div><div class="exit" onclick="closeSlider(this,' + currentPos + ')"></div></div>';
    $(_elem).parent().parent().parent().parent().parent().parent().parent().children().toggleClass('hideElem');
    $(_elem).parent().parent().parent().parent().parent().parent().parent().prepend(output);
    setTimeout(function () {
        initGallerySlider('#gal' + input.slideId);

    }, 300);

}

function openGalleryBig(_elem, _galId, _itemId) {
    var bg = '';
    var currentPos = parseInt($(_elem).offset().top);
    var itemNr = $(_elem).attr('data-slideItem');
    var output = '<div class="galWrapper"><div id="gal' + _galId + '" class ="iosSliderGal"><div class="slider">';
    $('#' + _galId + ' .thumbItem').each(function () {
        bg = $(this).css('background-image');
        bg = bg.replace('url(', '').replace(')', '').replace('"', '').replace('"', '').replace('thumbs', 'big');
        itemNr = $(this).attr('data-slideItem');
        output += '<div class = "slide item' + itemNr + '"style="background-image:url(\'' + bg + '\')"></div>';
    });
    output += '</div></div><div class="navButtons"><div class="prev"><i class="fa fa-chevron-left" aria-hidden="true"></i></div><div class="next"><i class="fa fa-chevron-right" aria-hidden="true"></i></div></div><div class="exit" onclick="closeGalSlider(this,' + currentPos + ')"></div></div>';
    $(_elem).parent().parent().parent().children().toggleClass('hideElem');
    $(_elem).parent().parent().parent().parent().parent().parent().prepend(output);
    setTimeout(function () {
        initGallerySlider('#gal' + _galId, _itemId);
    }, 300);

}


function openGalleryInner(_elem) {
    var currentPos = parseInt($(_elem).offset().top);
    var input = JSON.parse($(_elem).attr('data-slideItems'));
    var output = '<div class="galWrapper"><div id="gal' + input.slideId + '" class = "iosSliderGal"><div class = "slider">';
    for(var i in input.slideEl) {
        var slideNr = (parseInt(i) + parseInt(1));
        //var cleanTxt = decodeURI(input.slideTxt[i]);
        var cleanTxt = input.slideTxt[i];
        cleanTxt = decodeURIComponent(cleanTxt.replace(/\+/g, ' '));

        output += '<div class = "slide item' + slideNr + '"style="background-image:url(\'' + input.slideEl[i] + '\')"><p class="tSliderTxt">' + cleanTxt + '</p></div>';
    }
    output += '</div></div><div class="navButtons"><div class="prev"><i class="fa fa-chevron-left" aria-hidden="true"></i></div><div class="next"><i class="fa fa-chevron-right" aria-hidden="true"></i></div></div><div class="exit" onclick="closeSlider(this,' + currentPos + ')"></div></div>';
    $(_elem).parent().parent().parent().parent().parent().parent().parent().children().toggleClass('hideElem');
    $(_elem).parent().parent().parent().parent().parent().parent().parent().prepend(output);
    setTimeout(function () {
        initGallerySlider('#gal' + input.slideId);

    }, 300);

}

function closeSlider(_elem, currentPos) {
    $(_elem).parent().parent().children().toggleClass('hideElem');
    $(_elem).parent().remove();
    scrollToY(currentPos);

}

function closeGalSlider(_elem, currentPos) {
    $(_elem).parent().remove();
    $('.hideElem').toggleClass('hideElem');
    scrollToY(currentPos);

}



